module.exports = __webpack_public_path__ + "img/8.c689c60c.png";